import { useConext as useReactConext } from 'react'

export const useContext = useReactConext

export default useContext
